export default ["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
    // Now set up the states
    $stateProvider
        .state('messageInbox', {
            parent : "app",
            url: "/messageinbox?downloadError&title&createdAtFrom&createdAtUntil",
            feature: "menu.messages.inbox",
            views: {
                "main": {
                    template: require("./eaMessageInboxPage/eaMessageInboxPageModule.html"),
                    controller: "eaMessageInboxPageModuleController as $ctrl"
                }
            },
            resolve : {
                ctrl : ["$q","$ocLazyLoad", ($q,$ocLazyLoad)=> {
                    return $q((resolve)=>{
                        require.ensure([],()=>{

                            let module = require("./index.js");
                            $ocLazyLoad.load({name : module.default});
                            resolve();
                        });
                    });
                }]
            }
        })
        .state("messageDetails",{
            parent : "app",
            url: "/message/:id",
            feature: "menu.messages.inbox",
            views: {
                "main": {
                    template: require("./eaMessageDetailPage/eaMessageDetailPage.tpl.html"),
                    controller: "MessageDetailPageController as $ctrl"
                }
            },
            resolve : {
                ctrl : ["$q","$ocLazyLoad", ($q,$ocLazyLoad)=> {
                    return $q((resolve)=>{
                        require.ensure([],()=>{
                            let module = require("./index.js");
                            $ocLazyLoad.load({name : module.default});
                            resolve();
                        });
                    });
                }]
            }
        });
}];


// WEBPACK FOOTER //
// ./src/ui/modules/eaMessage/eaMessageInbox/routes.js